const AccountListFactory = function ($resource, $window) {
    const liveUrl = __baseApiUrl__ + "/participant-web-services/rest/accounts/summary";
    const mockUrl = "assets/data/get-account-summary.json";

    return {
        accountSummary: $resource(
            liveUrl,

            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    }; // End of return
};

AccountListFactory.$inject = ["$resource", "$window"];
export default AccountListFactory;
